/**
 * Created by hieult on 11/1/17.
 */
export const SHOW_MEMBER_PROFILE_MODAL = 'SHOW_MEMBER_PROFILE_MODAL';
export const SHOW_REPORT_MODAL = 'SHOW_REPORT_MODAL';
export const SHOW_REPORT_INPUT_MODAL = 'SHOW_REPORT_INPUT_MODAL';
export const SHOW_PROFILE_SUMMARY_MODAL = 'SHOW_PROFILE_SUMMARY_MODAL';
export const SHOW_FRIENDS_AND_FAVORITES_FILTER = 'SHOW_FRIENDS_AND_FAVORITES_FILTER';
export const SHOW_DELETE_MSG_CONVERSATION = 'SHOW_DELETE_MSG_CONVERSATION';
export const CLOSE_DELETE_MSG_CONVERSATION = 'CLOSE_DELETE_MSG_CONVERSATION';

export const SHOW_CONVERSATIONS_FILTER = 'SHOW_CONVERSATIONS_FILTER';
export const SHOW_VIDEOCALL_NOTIFY = 'SHOW_VIDEOCALL_NOTIFY';
export const ON_DELETE_CONVERSATION = 'ON_DELETE_CONVERSATION';
export const ON_DELETE_CONVERSATION_MODAL = 'ON_DELETE_CONVERSATION_MODAL';
export const SHOW_REMAIN_MESSAGE = 'SHOW_REMAIN_MESSAGE';

export const SHOW_FORM_QUICK_MESSAGE = 'SHOW_FORM_QUICK_MESSAGE';
export const ADD_FORM_FOR_INPUT = 'ADD_FORM_FOR_INPUT';

export const PRESS_DELETE_CONVERSATION = 'PRESS_DELETE_CONVERSATION';
export const PRESS_BLOCK_USER = 'PRESS_BLOCK_USER';
export const PRESS_BLOCK_USER_FROM_TODAY_PICK = 'PRESS_BLOCK_USER_FROM_TODAY_PICK';
export const PRESS_BLOCK_USER_VIDEO_CALL = 'PRESS_BLOCK_USER_VIDEO_CALL';
export const EMPTY_FRIEND_FILTER = 'EMPTY_FRIEND_FILTER';
export const CHANGE_TAB = 'CHANGE_TAB';

export const ON_BLOCK_USER = 'ON_BLOCK_USER';

export const ON_PRESS_PHOTO = 'ON_PRESS_PHOTO';

export const ON_PRESS_SIGN_UP = 'ON_PRESS_SIGN_UP';
export const ON_PRESS_CONNECT_FB = 'ON_PRESS_CONNECT_FB';

export const SHOW_PADDING_BOTTOM_CONVERSATION_DETAIL = 'SHOW_PADDING_BOTTOM_CONVERSATION_DETAIL';

export const ON_PRESS_BACK_ANDROID = 'ON_PRESS_BACK_ANDROID';

export const ON_SHOW_MODAL_CONFIRM_LOCATION = 'ON_SHOW_MODAL_CONFIRM_LOCATION';
export const SHOW_VIDEOCALL_VIEW = 'SHOW_VIDEOCALL_VIEW';
export const CLOSE_VIDEOCALL_VIEW = 'CLOSE_VIDEOCALL_VIEW';

export const SHOW_INCOMING_VIEW = 'SHOW_INCOMING_VIEW';
export const CLOSE_INCOMING_VIEW = 'CLOSE_INCOMING_VIEW';

export const SHOW_VIDEOCALL_VIEW_CONTAINER = 'SHOW_VIDEOCALL_VIEW_CONTAINER';
export const CLOSE_VIDEOCALL_VIEW_CONTAINER = 'CLOSE_VIDEOCALL_VIEW_CONTAINER';
export const SHOW_LOCAL_STREAM = 'SHOW_LOCAL_STREAM';
export const END_LOCAL_STREAM = 'END_LOCAL_STREAM';

export const SWITCH_CAMERA = 'SWITCH_CAMERA';
export const TAKE_PICTURE = 'TAKE_PICTURE';
export const TAKE_PICTURE_SUCCESS = 'TAKE_PICTURE_SUCCESS';

export const SHOW_USER_PROFILE_VIEW = 'SHOW_USER_PROFILE_VIEW';
export const CLOSE_USER_PROFILE_VIEW = 'CLOSE_USER_PROFILE_VIEW';

export const SHOW_OUT_OF_LIKE_MODAL = 'SHOW_OUT_OF_LIKE_MODAL';
export const CLOSE_OUT_OF_LIKE_MODAL = 'CLOSE_OUT_OF_LIKE_MODAL';

export const SHOW_MATCHING_MODAL = 'SHOW_MATCHING_MODAL';
export const CLOSE_MATCHING_MODAL = 'CLOSE_MATCHING_MODAL';

export const SHOW_INTERNATIONAL_MODAL = 'SHOW_INTERNATIONAL_MODAL';
export const CLOSE_INTERNATIONAL_MODAL = 'CLOSE_INTERNATIONAL_MODAL';

export const SHOW_SAFE_MODE_MODAL = 'SHOW_SAFE_MODE_MODAL';
export const CLOSE_SAFE_MODE_MODAL = 'CLOSE_SAFE_MODE_MODAL';

export const SHOW_CONVERSATION_MODAL = 'SHOW_CONVERSATION_MODAL';
export const CLOSE_CONVERSATION_MODAL = 'CLOSE_CONVERSATION_MODAL';

export const SHOW_WHISPER_VIEW = 'SHOW_WHISPER_VIEW';
export const CLOSE_WHISPER_VIEW = 'CLOSE_WHISPER_VIEW';

export const SHOW_MEMBERS_CHATROOM_MODAL = 'SHOW_MEMBERS_CHATROOM_MODAL';
export const CLOSE_MEMBERS_CHATROOM_MODAL = 'CLOSE_MEMBERS_CHATROOM_MODAL';

export const SHOW_SEARCH_FILTER = 'SHOW_SEARCH_FILTER';
export const SHOW_QUICK_MESSAGE_MODAL = 'SHOW_QUICK_MESSAGE_MODAL';
export const SHOW_DIRECT_MESSENGER_SETTING = 'SHOW_DIRECT_MESSENGER_SETTING';
export const SEND_PHOTO_EVENT = 'SEND_PHOTO_EVENT';

export const CLEAR_COUNTDOWN = 'CLEAR_COUNTDOWN';

export const STOP_VIDEO = 'STOP_VIDEO';

export const SHOW_WEB_VIEW_MODAL = 'SHOW_WEB_VIEW_MODAL';
export const CLOSE_WEB_VIEW_MODAL = 'CLOSE_WEB_VIEW_MODAL';

export const SHOW_CUSTOM_TOAST = 'SHOW_CUSTOM_TOAST';

//
export const SHOW_IN_APP_NOTIFICATION = 'SHOW_IN_APP_NOTIFICATION';
export const HIDE_IN_APP_NOTIFICATION = 'HIDE_IN_APP_NOTIFICATION';

export const SHOW_MEMBER_UPGRADE_VIEW = 'SHOW_MEMBER_UPGRADE_VIEW';
export const CLOSE_MEMBER_UPGRADE_VIEW = 'CLOSE_MEMBER_UPGRADE_VIEW';
export const IOS_PURCHASE_END = 'IOS_PURCHASE_END';
//
export const SHOW_FOLDER_FORM = 'SHOW_FOLDER_FORM';
export const PRESS_DELETE_FOLDER = 'PRESS_DELETE_FOLDER';
//
export const SEND_REPLY_GIFT_MESSAGE_MESSENGER_TOOLBAR = 'SEND_REPLY_GIFT_MESSAGE_MESSENGER_TOOLBAR';
//
export const SHOW_ON_BOARDING_VIEW = 'SHOW_ON_BOARDING_VIEW';
export const CLOSE_ON_BOARDING_VIEW = 'CLOSE_ON_BOARDING_VIEW';

// IN-app notification
export const SELECT_CONVERSATION_BY_IN_APP = 'SELECT_CONVERSATION_BY_IN_APP';
export const EVENT_AUTO_SELECT_FIRST_CONV = 'EVENT_AUTO_SELECT_FIRST_CONV';

// CLOSE-ALL-MODAL
export const CLOSE_ALL_MODAL = 'CLOSE_ALL_MODAL';

export const CLOSE_ALL_CALL_POP_UP = 'CLOSE_ALL_CALL_POP_UP';

export const LOGOUT = 'LOGOUT';
export const NO_INTERNET = 'NO_INTERNET';
export const CLOSE_NO_INTERNET = 'CLOSE_NO_INTERNET';

export const SHOW_ERROR_MODAL = 'SHOW_ERROR_MODAL';
export const CLOSE_ERROR_MODAL = 'CLOSE_ERROR_MODAL';

export const SHOW_FEATURE_MODAL = 'SHOW_FEATURE_MODAL';

export const SHOW_BLOCK_MODAL = 'SHOW_BLOCK_MODAL';

export const GET_PROSPECTS_DATA = 'GET_PROSPECTS_DATA';

export const SHOW_PRIVATE_MODAL = 'SHOW_PRIVATE_MODAL';

export const SHOW_NOT_INTERESTED_MODAL = 'SHOW_NOT_INTERESTED_MODAL';

export const OPEN_LIBRARY_WHEN_CALL = 'OPEN_LIBRARY_WHEN_CALL';

export const REJECT_CALL_FROM_MODAL_CONVERSATION = 'REJECT_CALL_FROM_MODAL_CONVERSATION';

export const ANSWER_CALL_FROM_MODAL_CONVERSATION = 'ANSWER_CALL_FROM_MODAL_CONVERSATION';

export const OPEN_CALL_BUBBLE_FROM_MODAL_CONVERSATION = 'OPEN_CALL_BUBBLE_FROM_MODAL_CONVERSATION';

export const SHOW_CREATE_POST_MODAL = 'SHOW_CREATE_POST_MODAL';
export const ANDROID_PURCHASE_BEGIN = 'ANDROID_PURCHASE_BEGIN';
export const ANDROID_PURCHASE_END = 'ANDROID_PURCHASE_END';
export const SHOW_FULL_TESTIMONIAL = 'SHOW_FULL_TESTIMONIAL';

export const OPEN_MODAL_RATING = 'OPEN_MODAL_RATING';
export const CLOSE_MODAL_RATING = 'CLOSE_MODAL_RATING';
export const OPEN_MODAL_CONFIRM_RATING = 'OPEN_MODAL_CONFIRM_RATING';
export const CLOSE_MODAL_CONFIRM_RATING = 'CLOSE_MODAL_CONFIRM_RATING';
export const OPEN_MODAL_INPUT_FEEDBACK = 'OPEN_MODAL_INPUT_FEEDBACK';
export const CLOSE_MODAL_INPUT_FEEDBACK = 'CLOSE_MODAL_INPUT_FEEDBACK';
export const SHOW_MAIN_PHOTO_RESTRICTED = 'SHOW_MAIN_PHOTO_RESTRICTED';
export const CLOSE_UP_LOADING_IMAGE = 'CLOSE_UP_LOADING_IMAGE';
export const OPEN_MODAL_FEATURE = 'OPEN_MODAL_FEATURE';
export const CLOSE_MODAL_FEATURE = 'CLOSE_MODAL_FEATURE';
export const SHOW_ACCOUNT_LOGIN_CONNECTED = 'SHOW_ACCOUNT_LOGIN_CONNECTED';
export const SHOW_GIFT_DECLINED_INFO = 'SHOW_GIFT_DECLINED_INFO';

export const SHOW_RHP_COIN_BUY_VIEW = 'SHOW_RHP_COIN_BUY_VIEW';
export const CLOSE_RHP_COIN_BUY_VIEW = 'CLOSE_RHP_COIN_BUY_VIEW';
export const CLOSE_NOT_ENOUGH_COIN_BUY_VIEW = 'CLOSE_NOT_ENOUGH_COIN_BUY_VIEW';
// Chatroom
export const QUIT_CHAT_ROOM = 'QUIT_CHAT_ROOM';

export const MESSENGER_UNAVAILABLE_MODAL_OPEN = 'MESSENGER_UNAVAILABLE_MODAL_OPEN';
export const SHOW_PROFILE_BOOST = 'SHOW_PROFILE_BOOST';
export const SHOW_PROFILE_BOOST_UPLOAD_PHOTO = 'SHOW_PROFILE_BOOST_UPLOAD_PHOTO';
export const SHOW_CONVERSATION_BOOST = 'SHOW_CONVERSATION_BOOST';
export const SHOW_VIDEO_FULL_SCREEN = 'SHOW_VIDEO_FULL_SCREEN';
export const SHOW_SPOTLIGHT_BOOST_INFO = 'SHOW_SPOTLIGHT_BOOST_INFO';
export const SHOW_FULL_SCREEN_PREVIEW = 'SHOW_FULL_SCREEN_PREVIEW';
export const CLOSE_FULL_SCREEN_PREVIEW = 'CLOSE_FULL_SCREEN_PREVIEW';

export const GET_SYNC_MESSAGE = 'GET_SYNC_MESSAGE';

export const LOTTIE_EVENT = {
  LOAD: 'load',
  ERROR: 'error',
  READY: 'ready',
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop',
  FREEZE: 'freeze',
  LOOP: 'loop',
  COMPLETE: 'complete',
  FRAME: 'frame',
};

export const AUTO_RUN_BLOCK_USER = 'AUTO_RUN_BLOCK_USER';

export const REPLACE_TEXT_TOOLBAR = 'REPLACE_TEXT_TOOLBAR';
export const USER_EXIT_VERIFICATION = 'USER_EXIT_VERIFICATION';

export const OPEN_REACTIVATE_ACCOUNT = 'OPEN_REACTIVATE_ACCOUNT';
export const RELOAD_TRAVEL_PLANS = 'RELOAD_TRAVEL_PLANS';
export const SHOW_BIOMETRIC_REQUIRE = 'SHOW_BIOMETRIC_REQUIRE';
export const SHOW_CUSTOM_MODAL = 'SHOW_CUSTOM_MODAL';
export const ON_CREATE_PASSWORD_DONE = 'ON_CREATE_PASSWORD_DONE';
export const NEW_DATE_FINDER = 'NEW_DATE_FINDER';

export const VERIFICATION_ERROR = 'VERIFICATION_ERROR';